import { createI18n, type I18n } from 'vue-i18n'
import enCommon from '../locales/en/common.json'
import esCommon from '../locales/es/common.json'
import enContacts from '../locales/en/contact.json'
import esContacts from '../locales/es/contact.json'
import enFollowMe from '../locales/en/follow-me.json'
import esFollowMe from '../locales/es/follow-me.json'
import esVoicemail from '../locales/es/voicemail.json'
import enVoicemail from '../locales/en/voicemail.json'
import enHistorical from '../locales/en/historical.json'
import esHistorical from '../locales/es/historical.json'
import enNotes from '../locales/en/notes.json'
import esNotes from '../locales/es/notes.json'
import enEzdialer from '../locales/en/ezdialer.json'
import esEzdialer from '../locales/es/ezdialer.json'
import enAiReports from '../locales/en/ai-reports.json'
import esAiReports from '../locales/es/ai-reports.json'

// type MessageSchema = typeof en

// const messages: Record<'es' | 'en', MessageSchema> = {
//   en,
//   es,
// }

// const savedLang = (localStorage.getItem('lang') as 'es' | 'en') || 'es'

// const setI18nLanguage = (i18n: I18n, locale: keyof typeof messages) => {
//   if (i18n.mode === 'legacy') {
//     i18n.global.locale = locale
//   } else {
//     ;(i18n.global.locale as unknown as { value: string }).value = locale
//   }
//   document.documentElement.lang = locale
// }

// const instanceI18n = createI18n<[MessageSchema], 'es' | 'en'>({
//   legacy: false,
//   locale: savedLang,
//   fallbackLocale: 'en',
//   globalInjection: true,
//   messages,
// })

// export { setI18nLanguage, instanceI18n }

export type MessageSchema = {
  common: typeof esCommon
  contact: typeof esContacts
  followMe: typeof esFollowMe
  voicemail: typeof esVoicemail
  historical: typeof esHistorical
  notes: typeof esNotes
  ezdial: typeof esEzdialer
  'ai-reports': typeof esAiReports
}

const messages: Record<'es' | 'en', MessageSchema> = {
  es: {
    common: esCommon,
    contact: esContacts,
    followMe: esFollowMe,
    voicemail: esVoicemail,
    historical: esHistorical,
    notes: esNotes,
    ezdial: esEzdialer,
    'ai-reports': esAiReports,
  },
  en: {
    common: enCommon,
    contact: enContacts,
    followMe: enFollowMe,
    voicemail: enVoicemail,
    historical: enHistorical,
    notes: enNotes,
    ezdial: enEzdialer,
    'ai-reports': enAiReports,
  },
}

const savedLang = (localStorage.getItem('lang') as 'es' | 'en') || 'es'

export function setI18nLanguage(i18n: I18n, locale: keyof typeof messages) {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale
  } else {
    ;(i18n.global.locale as unknown as { value: string }).value = locale
  }
  document.documentElement.lang = locale
}

export const instanceI18n = createI18n<[MessageSchema], 'es' | 'en'>({
  legacy: false,
  locale: savedLang,
  fallbackLocale: 'en',
  globalInjection: true,
  messages,
})
